/**
 * Array related queries and utilities
 */

import { gettext } from "i18n";

export const insertIntoList = (
  list: any,
  index: any,
  insertItem: any,
  replace: boolean = false
) => [
  ...list.slice(0, index),
  insertItem,
  ...list.slice(index + (replace ? 1 : 0)),
];

/**
 * Sorts an array of objects alphabetically by a specified key after translating the value
 * @param items - Array of objects to sort (can be null or undefined)
 * @param key - Key/property name to sort by
 * @returns A new sorted array (does not mutate the original), empty array of items is null/undefined
 */
export const sortByTranslatedKey = <T extends Record<string, any>>(
  items: T[] | null | undefined,
  key: keyof T
): T[] => {
  if (!items) {
    return [];
  }

  return [...items].sort((a, b) => {
    const valueA = gettext(String(a[key]));
    const valueB = gettext(String(b[key]));
    return valueA.localeCompare(valueB);
  });
};
